export const Colors = {
  Primary: "#a1cada",
  PrimaryHover: "#bddae5",
  Green: "#45bd4d",
} as const;
